export default {
  "content": "<circle cx=\"18\" cy=\"18\" r=\"16\" fill=\"#C9CBD4\" stroke=\"#fff\" stroke-width=\"4\"/><path d=\"M14.5 26.75v-7.36a3.187 3.187 0 01-1.77-1.05c-.487-.553-.73-1.217-.73-1.99v-5.6h1.2v5.6h1.3v-5.6h1.2v5.6H17v-5.6h1.2v5.6c0 .773-.243 1.437-.73 1.99a3.187 3.187 0 01-1.77 1.05v7.36h-1.2zm8.3 0v-6.4h-2.3v-6.1c0-1.053.32-1.9.96-2.54.64-.64 1.487-.96 2.54-.96v16h-1.2z\" fill=\"#fff\"/>",
  "attrs": {
    "width": "36",
    "height": "36",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};